import { AdminTableTypes } from "../types";

export const adminTableRoutes: AdminTableTypes[] = [
	AdminTableTypes.Approved,
];